import { Route, Routes } from 'react-router-dom';

import { ArtistDetailPage, ArtistsPage } from '@/features/artists';
import { CheckoutPage } from '@/features/checkout';
import { ContactPage } from '@/features/contact';
import { EventDetailPage, EventsPage } from '@/features/events';
import { HomePage } from '@/features/home';
import { NotFoundPage } from '@/features/notfound';
import { ShopPage } from '@/features/shop';
import { TicketsPage } from '@/features/tickets';
import Shell from '@/layout/Shell';

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<HomePage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="events/:id" element={<EventDetailPage />} />
        <Route path="artists" element={<ArtistsPage />} />
        <Route path="artists/:slug" element={<ArtistDetailPage />} />
        <Route path="tickets/:id" element={<TicketsPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="shop" element={<ShopPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
